import { InfoLabel } from 'bold-ui'
import React from 'react'
import { formatDate } from 'util/date/formatDate'

import { ResultadoEspecificoPrenatal } from '../../model'

interface ResultadoExamePrenatalViewProps {
  value: ResultadoEspecificoPrenatal
}

export const ResultadoExamePrenatalView = (props: ResultadoExamePrenatalViewProps) => {
  const {
    value: {
      dpp,
      idadeGestacional: { semanas, dias },
    },
  } = props

  return (
    <InfoLabel title='Resultado'>{`Idade gestacional eco ${semanas} semana${semanas > 1 ? 's' : ''} ${
      dias ? `e ${dias} dia${dias > 1 ? 's' : ''}` : ''
    } - DPP eco ${formatDate(dpp)}`}</InfoLabel>
  )
}
